import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=a27d7a44&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=js&"
export * from "./sideBar.vue?vue&type=script&lang=js&"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=a27d7a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27d7a44",
  null
  
)

export default component.exports